import { render } from "./BaseMultiValue2.vue?vue&type=template&id=4505ef9f"
import script from "./BaseMultiValue2.vue?vue&type=script&lang=js"
export * from "./BaseMultiValue2.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__